var _a;
import { generatePromises } from "../generators/generator.promises";
import { GENERATOR_PARAMS } from "./payin.constants";
export var getPaged = (_a = generatePromises(GENERATOR_PARAMS), _a.getPaged), getDetail = _a.getDetail;
